import React from 'react'
import { useTranslation } from 'react-i18next'
import { Globe } from 'lucide-react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  const { t, i18n } = useTranslation()

  const currentLang = i18n.resolvedLanguage || i18n.language

  const toggleLanguage = () => {
    i18n.changeLanguage(currentLang === 'ja' ? 'en' : 'ja')
  }

  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <a href="/">
            <div
              aria-label={t('nav.brandNameFull')}
              className="navigation-logo-link"
            >
              <div className="navigation-logo-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <path d="m9 10l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <span className="section-title">{t('nav.brandName')}</span>
            </div>
          </a>
          <div className="navigation-desktop-menu">
            <ul className="navigation-links-list">
              <li className="navigation-link-item">
                <a href="#usecase">
                  <div className="navigation-thq-navigation-link-elm1 navigation-link">
                    <span>{t('nav.usecase')}</span>
                  </div>
                </a>
              </li>
              <li className="navigation-link-item">
                <a href="#feature">
                  <div className="navigation-thq-navigation-link-elm2 navigation-link">
                    <span>{t('nav.features')}</span>
                  </div>
                </a>
              </li>
            </ul>
            <button
              onClick={toggleLanguage}
              className="navigation-lang-btn"
              aria-label="Switch language"
            >
              <Globe size={16} />
              <span>{currentLang === 'ja' ? 'EN' : 'JA'}</span>
            </button>
            <a
              href="https://point.place"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="btn-primary btn-sm btn">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                    <path d="M2 12h20"></path>
                  </g>
                </svg>
                <span>{t('nav.viewOnWeb')}</span>
              </div>
            </a>
            <a href="#download">
              <div className="btn-primary btn-sm btn">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 15V3m9 12v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <path d="m7 10l5 5l5-5"></path>
                  </g>
                </svg>
                <span>{t('nav.getApp')}</span>
              </div>
            </a>
          </div>
          <button
            id="navToggle"
            aria-label="Toggle Menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              className="icon-menu"
            >
              <path
                d="M4 6h16M4 12h16M4 18h16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <div className="navigation-logo-link">
            <div className="navigation-logo-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <path d="m9 10l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <span className="section-title">{t('nav.brandNameFull')}</span>
          </div>
          <button
            id="navClose"
            aria-label="Close Menu"
            className="navigation-mobile-close"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="3" rx="2" width="18" height="18"></rect>
                <path d="M3 9h18M9 16l3-3l3 3"></path>
              </g>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <ul className="navigation-overlay-links">
            <li className="navigation-overlay-item">
              <a href="#usecase">
                <div className="navigation-overlay-link">
                  <span>{t('nav.usecase')}</span>
                </div>
              </a>
            </li>
            <li className="navigation-overlay-item">
              <a href="#feature">
                <div className="navigation-overlay-link">
                  <span>{t('nav.features')}</span>
                </div>
              </a>
            </li>
            <li className="navigation-overlay-item">
              <a
                href="https://point.place"
                target="_blank"
                rel="noreferrer noopener"
              >
                <div className="navigation-overlay-link">
                  <span>{t('nav.viewOnWeb')}</span>
                </div>
              </a>
            </li>
            <li className="navigation-overlay-item">
              <button
                onClick={toggleLanguage}
                className="navigation-overlay-link navigation-lang-btn-mobile"
              >
                <Globe size={20} />
                <span>{currentLang === 'ja' ? 'English' : '日本語'}</span>
              </button>
            </li>
          </ul>
          <div className="navigation-overlay-footer">
            <a href="#download">
              <div className="btn-lg btn-primary btn">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 15V3m9 12v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <path d="m7 10l5 5l5-5"></path>
                  </g>
                </svg>
                <span>{t('nav.getApp')}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay {
  transition: none;
}
.navigation-overlay-link {
  transition: none;
  opacity: 1;
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById("navToggle")
  const navClose = document.getElementById("navClose")
  const mobileOverlay = document.getElementById("mobileOverlay")
  const overlayLinks = document.querySelectorAll(".navigation-overlay-link")
  const footerLinks = document.querySelectorAll(".navigation-overlay-footer a")

  const openMenu = () => {
    mobileOverlay.style.display = "flex"
    setTimeout(() => {
      mobileOverlay.classList.add("is-active")
      navToggle.setAttribute("aria-expanded", "true")
      document.body.style.overflow = "hidden"
    }, 10)
  }

  const closeMenu = () => {
    mobileOverlay.classList.remove("is-active")
    navToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
    setTimeout(() => {
      if (!mobileOverlay.classList.contains("is-active")) {
        mobileOverlay.style.display = "none"
      }
    }, 400)
  }

  navToggle.addEventListener("click", openMenu)
  navClose.addEventListener("click", closeMenu)

  overlayLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  footerLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileOverlay.classList.contains("is-active")) {
      closeMenu()
    }
  })

  window.addEventListener("resize", () => {
    if (window.innerWidth > 767 && mobileOverlay.classList.contains("is-active")) {
      closeMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
